import React from 'react';
import { FormGroup } from 'reactstrap';

//{ labelText, controlName, control, validations, errors, children }
const FormControl = (props) => {
    const { errors, name, labelText } = props;
    const labelClass = errors && "text-danger";
    const inputClass = "form-control " + ( errors ? " is-invalid " : "" );

    return (
        <FormGroup>
            <label className={labelClass} htmlFor={name}>{labelText}</label>
            {props.render({ inputClass, ...props })}
            {errors && <span className="text-sm text-danger">{errors.message}</span>}
        </FormGroup>
    );
}

export default FormControl;